import { AfterViewInit, Directive, ElementRef, forwardRef, output, inject } from '@angular/core';
import { AbstractControlValueAccessor } from '../../../shared/abstract_control_value_accessor.abstract';
import { NG_VALIDATORS, NG_VALUE_ACCESSOR, UntypedFormControl, ValidationErrors } from '@angular/forms';

@Directive({
  selector: '[appAdvancedTos]',
  providers: [
    { provide: NG_VALUE_ACCESSOR, useExisting: forwardRef(() => AdvancedTosDirective), multi: true },
    { provide: NG_VALIDATORS, useExisting: forwardRef(() => AdvancedTosDirective), multi: true },
  ],
})
export class AdvancedTosDirective extends AbstractControlValueAccessor implements AfterViewInit {

  public readonly tosShow = output<void>();

  public formControl: UntypedFormControl = new UntypedFormControl(false);
  private element: ElementRef;
  private checkboxes: any[];

  constructor() {
    const elementRef = inject(ElementRef);

    super();
    this.element = elementRef;
  }

  public ngAfterViewInit(): void {

    this.checkboxes = this.element.nativeElement.querySelectorAll('input[type=checkbox]');
    let counter = 0;

    for (const checkbox of this.checkboxes) {
      checkbox.addEventListener('click', e => {
        e.target.checked ? counter++ : counter--;
        this.formControl.setValue(counter === this.checkboxes.length);
        this.onTouched();
        this.onChange(this.formControl.value);
      });
    }

    const tosShows = this.element.nativeElement.querySelectorAll('.js-tos-show');

    for (const toslink of tosShows) {
      toslink.addEventListener('click', (e) => {
        e.stopPropagation();
        e.preventDefault();
        // TODO: The 'emit' function requires a mandatory void argument
        this.tosShow.emit();
      });
    }
  }

  public writeValue(): void {
  }

  public validate(): ValidationErrors | any {
    if (this.checkboxes) {
      return this.formControl.value ? null : { tos_unchecked: true };
    }
    return { tos_unchecked: true };
  }
}
